import { alpha, Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  background: theme.palette.background.primary,
  '& .TVHeroContainer': {
    position: 'relative',
    paddingTop: theme.spacing(3),
  },
  '& .TVBGContainer': {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 0,
    '&:after': {
      content: '""',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height: '80%',
      zIndex: 1,
      background: `linear-gradient(to top, ${theme.palette.background.primary} 0%, transparent 100%)`,
    },
  },
  '& .TVContantContainer': {
    position: 'relative',
    zIndex: 2,
    marginTop: theme.spacing(12),
  },
  '& .TVRelatedContainer': {
    padding: theme.spacing(0, 8),
    [theme.breakpoints.down('xl')]: {
      padding: theme.spacing(0, 4),
    },
  },
  '& .TVV2RightSide': {
    [theme.breakpoints.up('lg')]: {
      position: 'sticky',
      top: 24,
    },
  },
  '& .TVV2WidgetContainer': {
    backgroundColor: alpha(theme.palette.secondary.main, 0.8),
    border: '1px solid',
    borderColor: theme.palette.divider[7],
    padding: theme.spacing(1),
    borderRadius: 8,
  },
}));

export default StyledBox;
